// extracted by mini-css-extract-plugin
export var mt0 = "spinner-loader-module--mt-0--0b4f7";
export var mt1 = "spinner-loader-module--mt-1--f9e6a";
export var mt2 = "spinner-loader-module--mt-2--e8708";
export var mt3 = "spinner-loader-module--mt-3--0684e";
export var mt4 = "spinner-loader-module--mt-4--0b9e1";
export var mt5 = "spinner-loader-module--mt-5--76fc0";
export var mt6 = "spinner-loader-module--mt-6--21598";
export var spinKeyframes = "spinner-loader-module--spinKeyframes--5a7e4";
export var spinnerLoader = "spinner-loader-module--spinner-loader--5cb73";